"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var range_slider_1 = require("../../controls/range-slider");
wp.customize.controlConstructor['epsilon-slider'] = wp.customize.Control.extend({
    ready: function () {
        var control = this;
        new range_slider_1.EpsilonRangeSlider(control);
        control.container.on('change', 'input.rl-slider', function (event) {
            control.setting.set(jQuery(event.target).val());
        });
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/vendors/epsilon-framework/customizer/extenders/controls/range-slider.ts
// module id = 21
// module chunks = 0